<template>
  <div class="editPhone">
    <div class="editPhone-tips">
      <p class="title">
        <span class="tips-title">修改登录手机</span>
        <span class="under_line"></span>
        <span class="tips-bar">
          <span class="step1_bar" :class="{stepPass:tipPass1 && tipPass2,stepCurrent:tipPass1}">
            手机效验
            <i class="dot" :class="{pass:tipPass1 && tipPass2}"></i>
          </span>
          <span
            class="step2_bar"
            :class="{stepPass:tipPass1 && tipPass2 && tipPass3,stepCurrent:tipPass1 && tipPass2}"
          >
            设置登录手机
            <i class="dot" :class="{pass:tipPass1 && tipPass2 && tipPass3}"></i>
          </span>
          <span
            class="step3_bar"
            :class="{stepPass:tipPass1 && tipPass2 && tipPass3 && tipPass4,stepCurrent:tipPass1 && tipPass2 && tipPass3}"
          >
            再次校验
            <i class="dot" :class="{stepCurrent:tipPass1 && tipPass2 && tipPass3 && tipPass4}"></i>
          </span>
          <span
            class="step4_bar"
            :class="{stepCurrent:tipPass1 && tipPass2 && tipPass3 && tipPass4}"
          >绑定成功</span>
        </span>
        <span
          class="under_line_move"
          :class="{move_step1:tipPass1,move_step2:tipPass2,move_step3:tipPass3,move_step4:tipPass4,}"
        ></span>
      </p>
    </div>
    <div class="editPhone_content" v-show="!tipPass4">
      <span class="editPhone_logo"></span>
      <el-form
        ref="editPhoneForm"
        :model="editPhoneForm"
        :rules="editPhoneFormRules"
        class="login-form"
        autocomplete="on"
        @submit.native.prevent
      >
        <div class="change-Part">
          <div class="step1" v-show="tipPass1 && !tipPass2">
            <p class="step1-tips">安全校验手机号</p>
            <p class="old_phone">{{userInfo.mobile | hiddenPhoneNum}}</p>
            <div class="check-phonecode-div">
              <el-form-item class="phone-code" prop="phoneCode">
                <el-input
                  ref="phoneCode"
                  v-model.trim="editPhoneForm.phoneCode"
                  placeholder="验证码"
                  name="phoneCode"
                  type="tel"
                  maxlength="6"
                  @keyup.enter.native="nextFn()"
                />
                <el-button
                  :class="{'is-timing':able}"
                  class="codeBtn"
                  :disabled="able"
                  type="primary"
                  @click="getCode"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show">{{count}} s</span>
                </el-button>
              </el-form-item>
            </div>
          </div>
          <div class="step2" v-show="tipPass1 && tipPass2 && !tipPass3">
            <p class="step2-tips">该手机号用于登录您的账号</p>
            <div class="changePhone-div">
              <el-form-item class="changePhone" prop="newphone">
                <el-input
                  ref="newphone"
                  v-model.number="editPhoneForm.newphone"
                  placeholder="请输入手机号"
                  name="newphone"
                  maxlength="11"
                  @keyup.enter.native="nextFn()"
                />
              </el-form-item>
            </div>
          </div>
          <div class="step3" v-show="tipPass1 && tipPass2 && tipPass3 && !tipPass4">
            <p class="step3-tips">环球网通过手机短信将验证码发送到了</p>
            <p class="new_phone">{{editPhoneForm.newphone | hiddenPhoneNum}}</p>
            <div class="check-newphonecode-div">
              <el-form-item class="newphone-code" prop="newphoneCode">
                <el-input
                  ref="newphoneCode"
                  v-model.trim="editPhoneForm.newphoneCode"
                  placeholder="验证码"
                  name="newphoneCode"
                  @keyup.enter.native="nextFn()"
                />
              </el-form-item>
              <div class="againSendMsg-div">
                没有收到？
                <span class="againSendMsg" @click="getCodeNew">重新发送</span>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div class="editPhone_control" :class="{beginEdit:!(tipPass1 && tipPass2)}">
        <span
          class="pre-step whiteBtn"
          :class="{unAble:whiteLikeAble}"
          v-if="tipPass1 && tipPass2"
          @click="prevFn()"
        >上一步</span>
        <span class="next-step blueBtn" :class="{unAble:blueLikeAble}" @click="nextFn()">下一步</span>
      </div>
    </div>
    <div class="step4" v-show="tipPass1 && tipPass2 && tipPass3 && tipPass4">
      <span class="success-logo"></span>
      <div class="success-tips">
        <p class="success-title">绑定成功</p>
        <p class="success-content">
          登录手机号为：
          <span class="success-content-newphone">{{editPhoneForm.newphone}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
import Bus from '@/utils/Bus.js'

export default {
  name: "editPhone",
  components: {},
  data() {
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入6位短信验证码"));
      } else {
        callback();
      }
    };
    const validPhoneNumber = (rule, value, callback) => {
      if (("" + value).length !== 11) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    return {
      tipPass1: true,
      phonePassed: false,
      tipPass2: false,
      tipPass3: false,
      tipPass4: false,
      show: true,
      able: false,
      whiteLikeAble: false,
      blueLikeAble: false,
      timer: null,
      count: "",
      getNewCodeBool: true,
      editPhoneForm: {
        oldphone: "",
        phoneCode: "",
        newphoneCode: "",
        newphone: ""
      },
      editPhoneFormRules: {
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ],
        newphone: [
          { required: true, trigger: "blur", validator: validPhoneNumber }
        ],
        newphoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ]
        // code: [{ required: true, trigger: "blur",validator: validateCode }],
        // phoneCode: [
        //   { required: true, trigger: "blur",validator: validatePhoneCode },
        //   { type: "number", message: "验证码应为数字值", trigger: "blur" }
        // ]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    getCode() {
      user
        .getOldMsgBindPhone(this.userInfo.mobile)
        .then(result => {
          // this.$Message.success(result.data.message);
        })
        .catch(err => {
          console.log(err);
        });
      // 发送请求获取验证码
      this.able = true;
      // 倒计时
      const TIME_COUNT = 90;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getCodeNew() {
      if (!this.getNewCodeBool) {
        return;
      }
      // 发送请求获取验证码
      this.getNewCodeBool = false;
      user
        .getMsgBindPhone(this.editPhoneForm.newphone)
        .then(result => {
          // this.$Message.success(result.data.message);
        })
        .catch(err => {
          console.log(err);
        });
      setTimeout(() => {
        this.getNewCodeBool = true;
      }, 3000);
    },
    handCheckCode() {
      this.$refs.editPhoneForm.validateField("phoneCode", valid => {
        if (!valid) {
          //校验验证码
          user
            .bindPhoneCheck({
              mobile: this.userInfo.mobile,
              mobile_verify_code: this.editPhoneForm.phoneCode
            })
            .then(result => {
              // this.$Message.success(result.data.message);
              this.tipPass2 = true;
              this.phonePassed = true;
            })
            .catch(err => {
              console.log(err);
              if (!this.agreeMent) {
                if (
                  document.getElementsByClassName("el-message").length === 0
                ) {
                  this.$Message({ message: err, type: "warning" });
                }
                return;
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handCheckNewPhone() {
      this.$refs.editPhoneForm.validateField("newphone", valid => {
        if (!valid) {
          user
            .getMsgBindPhone(this.editPhoneForm.newphone)
            .then(result => {
              // this.$Message.success(result.data.message);
              this.tipPass3 = true;
            })
            .catch(err => {
              this.$Message({ message: err, type: "warning" });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handCheckNewPhoneCode() {
      this.$refs.editPhoneForm.validateField("newphoneCode", valid => {
        if (!valid) {
          user
            .bindPhone({
              mobile: this.editPhoneForm.newphone,
              mobile_verify_code: this.editPhoneForm.newphoneCode
            })
            .then(result => {
              this.tipPass4 = true;
              Bus.$emit('changePhone',this.editPhoneForm.newphone)
              setTimeout(() => {
                this.$router.push({ name: "index" });
              }, 3000);
            })
            .catch(err => {
              console.log(err);
              this.$Message({ message: err, type: "warning" });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    prevFn() {
      if (this.whiteLikeAble) {
        return;
      }
      if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.tipPass2 = false;
      } else if (
        this.tipPass1 &&
        this.tipPass2 &&
        this.tipPass3 &&
        !this.tipPass4
      ) {
        this.tipPass3 = false;
      }
    },
    nextFn() {
      if (this.blueLikeAble) {
        return;
      }
      if (this.tipPass1 && !this.tipPass2) {
        if (this.phonePassed) {
          this.tipPass2 = true;
        } else {
          this.handCheckCode();
        }
      } else if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.handCheckNewPhone();
      } else if (
        this.tipPass1 &&
        this.tipPass2 &&
        this.tipPass3 &&
        !this.tipPass4
      ) {
        this.handCheckNewPhoneCode();
      }
    }
  },
  created() {},
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.editPhone {
  position: relative;
  .editPhone-tips {
    width: 640px;
    margin: 30px 40px 0;
    border-bottom: 1px solid #e5e5e5;
    .title {
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 700;
      font-size: 20px;
      line-height: 40px;
      letter-spacing: 0px;
      text-align: left;
      padding-left: 30px;
      position: relative;
      .under_line {
        width: 60px;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 60px;
        background-color: orange;
      }
      .tips-bar {
        color: #b2b2b2;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: left;
        padding-left: 107px;
        .stepCurrent {
          color: #4c4c4c;
        }
        .stepPass {
          color: #4e9e2f;
        }

        .dot {
          background: #c9c9c9;
          width: 3px;
          height: 3px;
          border-radius: 3px;
          display: inline-block;
          margin: 0 5px 4px;
          margin-bottom: 4px;
        }
        .pass {
          background: #4e9e2f;
        }
      }
      .under_line_move {
        width: 60px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 266px;
        background-color: orange;
      }
      .move_step1 {
        left: 266px;
      }
      .move_step2 {
        left: 370px;
      }
      .move_step3 {
        left: 472px;
      }
      .move_step4 {
        left: 560px;
      }
    }
  }
  .editPhone_content {
    width: 400px;
    height: 260px;
    border-radius: 6px;
    background: #f3f2f0;
    position: absolute;
    left: 165px;
    top: 150px;
    .editPhone_logo {
      width: 112px;
      height: 112px;
      position: absolute;
      top: -56px;
      left: 144px;
      display: inline-block;
      background: url("../../../assets/images/icon-1.png") no-repeat center;
    }
    .change-Part {
      margin-top: 70px;
      .step1 {
        .step1-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .old_phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-phonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 150px;
          position: relative;
          .el-input {
            width: 148px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
          .el-button.codeBtn {
            width: 100px;
            height: 40px;
            position: absolute;
            right: -110px;
            top: 0;
            padding: 0;
            color: #fff;
            border-radius: 6px;
            background: #4981f2;
            box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
          }
        }
      }
      .step2 {
        .step2-tips {
          color: #595959;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
          margin-top: 24px;
        }
        .changePhone-div {
          .changePhone {
            width: 260px;
            height: 40px;
            border-radius: 6px;
            background: #ffffff;
            border: 1px solid #cccccc;
            box-shadow: inset 3px 3px 0px 0 #f2f2f2;
            margin: 20px auto;
          }
        }
      }
      .step3 {
        .step3-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .new_phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-newphonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 260px;
          position: relative;
          .el-form-item {
            margin-bottom: 10px;
          }
          .el-input {
            width: 258px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
        }
        .againSendMsg-div {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          letter-spacing: 0px;
          text-align: right;
          .againSendMsg {
            color: #4981f2;
            cursor: pointer;
          }
        }
      }
    }
    .editPhone_control {
      position: absolute;
      bottom: -14px;
      left: 55px;
      height: 28px;
      span {
        cursor: pointer;
        width: 128px;
        height: 28px;
        margin: 0 6px;
        border-radius: 14px;
        display: inline-block;
        text-align: center;
        color: #4981f2;
        font-family: Microsoft YaHei;
        line-height: 28px;
        font-size: 14px;
        letter-spacing: 0px;
        background: #ffffff;
        border: 1px solid #4981f2;
        box-shadow: inset 0px -2px 0px 0 #cccccc, 0px 2px 0px 0 #e5e5e5;
      }
      .next-step {
        color: #ffffff;
        background: #4981f2;
        box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
      }
    }
    .editPhone_control.beginEdit {
      left: 135px;
    }
  }
  .step4 {
    height: 234px;
    width: 200px;
    position: absolute;
    left: 260px;
    top: 215px;
    .success-logo {
      width: 170px;
      height: 170px;
      display: inline-block;
      background: url("../../../assets/images/icon-1a.png") no-repeat center;
      margin-left: 15px;
    }
    .success-tips {
      .success-title {
        margin-top: 10px;
        color: #000;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 22px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 6px;
      }
      .success-content {
        color: #4c4c4c;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: center;
        .success-content-newphone {
          color: #000;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/accBind/editPhone.vue